var AREA;
(function (AREA) {
    AREA["TEXT"] = "text";
    AREA["BACKGROUND"] = "background";
    AREA["BORDER"] = "border";
})(AREA || (AREA = {}));
export default AREA;
